var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4729 9.92554C13.7206 7.47185 16.5065 4.74557 17.9303 3.67878C13.9842 -0.85536 8.81495 0.189337 8.2068 0.312242C7.59865 0.435148 1.37946 1.71289 0.246708 8.47333C-0.88604 15.2338 4.95684 18.7898 5.49438 18.9838C6.03192 19.1777 9.89838 21.3282 14.6655 19.2275C19.4326 17.1268 21.9021 9.93973 22.6737 7.88484C23.2266 6.4125 24.2758 4.4147 24.9831 3.44156C25.0556 3.34181 24.9643 3.198 24.8432 3.22627C17.805 4.86843 12.6746 12.6113 11.6734 17.7663C11.0747 17.5326 7.76481 15.4157 7.25732 10.2492C6.74983 5.08275 6.48734 5.44186 6.1127 4.6168C9.83703 4.79898 11.9046 8.23187 12.4729 9.92554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIconWhite);
export default __webpack_public_path__ + "static/media/bankIconWhite.9f8f0a82c1700887e2aa57ea5b20ed85.svg";
export { ForwardRef as ReactComponent };